import { ActivationStatus } from "Apollo/fragments/person/Person";

export function displayDefaultColor(person: ILightPersonProfile | IPerson) {
    return person.status !== ActivationStatus.Activated || person.avatar?.initials?.length === 0;
}